{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} samtöl valin",
    "AGENT_SELECT_LABEL": "Velja þjónustufulltrúa",
    "ASSIGN_CONFIRMATION_LABEL": "Ertu viss um að úthluta {conversationCount} {conversationLabel} á",
    "UNASSIGN_CONFIRMATION_LABEL": "Ertu viss um að hætta við úthlutun {conversationCount} {conversationLabel}?",
    "GO_BACK_LABEL": "Go back",
    "ASSIGN_LABEL": "Úthluta",
    "YES": "Já",
    "SEARCH_INPUT_PLACEHOLDER": "Leit",
    "ASSIGN_AGENT_TOOLTIP": "Assign agent",
    "ASSIGN_TEAM_TOOLTIP": "Assign team",
    "ASSIGN_SUCCESFUL": "Conversations assigned successfully.",
    "ASSIGN_FAILED": "Failed to assign conversations. Please try again.",
    "RESOLVE_SUCCESFUL": "Conversations resolved successfully.",
    "RESOLVE_FAILED": "Failed to resolve conversations. Please try again.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Samtöl sem sjást á þessari síðu eru aðeins valin.",
    "AGENT_LIST_LOADING": "Loading agents",
    "UPDATE": {
      "CHANGE_STATUS": "Change status",
      "SNOOZE_UNTIL": "Snooze",
      "UPDATE_SUCCESFUL": "Conversation status updated successfully.",
      "UPDATE_FAILED": "Failed to update conversations. Please try again."
    },
    "LABELS": {
      "ASSIGN_LABELS": "Assign labels",
      "NO_LABELS_FOUND": "No labels found for",
      "ASSIGN_SELECTED_LABELS": "Assign selected labels",
      "ASSIGN_SUCCESFUL": "Labels assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign labels. Please try again."
    },
    "TEAMS": {
      "TEAM_SELECT_LABEL": "Velja teymi",
      "NONE": "Enginn",
      "NO_TEAMS_AVAILABLE": "There are no teams added to this account yet.",
      "ASSIGN_SELECTED_TEAMS": "Assign selected team.",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Failed to assign team. Please try again."
    },
    "MERGE": {
      "TOOLTIP": "Sameina samtöl",
      "TITLE": "Sameina samtöl",
      "DESCRIPTION": "Veldu marksamtal. Öll önnur valin samtöl verða sameinuð því — skilaboð þeirra verða flutt í marksamtalið og upprunalegu samtölin verða eytt.",
      "TARGET_LABEL": "Marksamtal (verður geymt)",
      "SOURCES_LABEL": "Upprunaleg samtöl (verða eytt)",
      "SELECT_TARGET": "Veldu samtal sem markmið sameiningar",
      "WARNING": "Viðvörun: Ekki er hægt að afturkalla þessa aðgerð. Skilaboð úr öllum upprunalegum samtölum verða flutt í marksamtalið og upprunalegu samtölin verða eytt varanlega.",
      "SUBMIT": "Sameina samtöl",
      "CANCEL": "Hætta við",
      "SUCCESS_MESSAGE": "Samtöl sameinuð",
      "ERROR_MESSAGE": "Ekki tókst að sameina samtöl. Vinsamlegast reyndu aftur.",
      "CONFIRM": {
        "TITLE": "Staðfesta sameiningu",
        "DESCRIPTION": "Ertu viss um að þú viljir sameina {sourceCount} samtöl í #{targetId}? Ekki er hægt að afturkalla þessa aðgerð.",
        "YES": "Já, sameina",
        "CANCEL": "Hætta við"
      }
    }
  }
}
